var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.token ? _c('iframe', {
    staticStyle: {
      "width": "0",
      "height": "0",
      "border": "0",
      "position": "absolute"
    },
    attrs: {
      "src": _vm.iframeSrc
    }
  }) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };